import { BillService } from "./service/bill";
import { CustomerService } from "./service/customer";
import { FranchiserService } from "./service/franchiser";
import { PaymentService } from "./service/payment";
import { PageOrderTag } from "./page/order-tag";
import { PageOrderTagProcessForm } from "./page/order-tag-process-form";
import { PageRegisterTag } from "./page/payment/register-tag/rs/tas";
import { PagePaymentProcessForm } from "./page/payment/process-form";
import { PageCustomerProfileBills } from "./page/customer-profile/bills";
import { PageCustomerProfileCards } from "./page/customer-profile/cards";
import { PageCustomerProfileTags } from "./page/customer-profile/tags/index";
import { PageCustomerProfileHistory } from "./page/customer-profile/history/index";
import { PageProcessFormMonri } from "./page/payment/process-form-monri/index";
import { PageRegisterTagFormMonriMK } from "./page/payment/register-tag/mk/monri/form";
import { PageRegisterTagProcessFormMonriMK } from "./page/payment/register-tag/mk/monri/process-form";
import { PageRegisterTagFormMonriRS } from "./page/payment/register-tag/rs/monri/form";
import { PageRegisterTagProcessFormMonriRS } from "./page/payment/register-tag/rs/monri/process-form";
import { PageRegisterTagFormTasMK } from "./page/payment/register-tag/mk/tas/form";
import { PageFrontPage } from "./page/front-page";
import { PagePaymentLoadingForm } from "./page/payment/success-response";
import { PageCustomerProfilePrepaidRefundRequest } from "./page/customer-profile/prepaid-refund-request";
import { PageRegisterTagFormTasHR } from "./page/payment/register-tag/hr/tas";
import { PageFrontPageT4A } from "./page/front-page/index-t4a";
import { PageRegisterTagFormOBO } from "./page/payment/register-tag/obo";
import { PageTagOrder } from "./page/payment/tag-order";
import './showAlert';

$(document).on('click', 'a[href*="/switch-language/"]', function (e) {
    const hash = window.location.hash;
    if (hash) {
        e.preventDefault();
        const url = new URL(this.href, window.location.origin);
        url.searchParams.set('anchor', hash.substring(1));
        window.location.href = url.toString();
    }
});

/*** General setup START ***/
$.ajaxSetup({
  headers: {
    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
  },
});
window.API = {};
// Services
API.service = {
  bill: BillService,
  customer: CustomerService,
  franchiser: FranchiserService,
  // actionLog: ActionLogService,
  payment: PaymentService,
};
// Page manager for routes
API.pageManager = {};

// Events
$("#modal_delete").on("show.bs.modal", function (e) {
  $(this).find(".btn-ok").attr("href", $(e.relatedTarget).data("href"));
});

/*** General setup END ***/

/*** Init pages controllers ***/
API.pageManager.orderTag = PageOrderTag;
API.pageManager.orderTagProcessForm = PageOrderTagProcessForm;
API.pageManager.registerTag = PageRegisterTag;
API.pageManager.paymentProcessForm = PagePaymentProcessForm;
API.pageManager.customerProfileBills = PageCustomerProfileBills;
API.pageManager.customerProfileCards = PageCustomerProfileCards;
API.pageManager.cutomerProfileTags = PageCustomerProfileTags;
// API.pageManager.adminActionLogs = PageAdminActionLogs;
API.pageManager.customerProfileHistory = PageCustomerProfileHistory;
API.pageManager.processFormMonri = PageProcessFormMonri;
API.pageManager.registerTagFormMonriMK = PageRegisterTagFormMonriMK;
API.pageManager.registerTagProcessFormMonriMK = PageRegisterTagProcessFormMonriMK;
API.pageManager.registerTagFormMonriRS = PageRegisterTagFormMonriRS;
API.pageManager.registerTagProcessFormMonriRS = PageRegisterTagProcessFormMonriRS;
API.pageManager.registerTagFormTasMK = PageRegisterTagFormTasMK;
API.pageManager.frontPage = PageFrontPage;
API.pageManager.paymentLoadingForm = PagePaymentLoadingForm;
API.pageManager.customerProfilePrepaidRefundRequest = PageCustomerProfilePrepaidRefundRequest;
API.pageManager.registerTagFormTasHR = PageRegisterTagFormTasHR;
API.pageManager.frontPageT4A = PageFrontPageT4A;
API.pageManager.registerTagFromOBO = PageRegisterTagFormOBO;
API.pageManager.tagOrder = PageTagOrder;
